"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDoctorSubstituteContractApiResponseSchema = exports.doctorSubstituteContractMetadata = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
exports.doctorSubstituteContractMetadata = zod_1.z.object({
    office: zod_1.z.object({
        name: zod_1.z.string(),
        address: address_schema_1.addressSchema,
    }),
    doctorAttending: zod_1.z.object({
        lastname: zod_1.z.string(),
        firstname: zod_1.z.string(),
        signatureUrl: zod_1.z.string(),
        orderRegistrationNumber: zod_1.z.string(),
    }),
    doctorSubstitute: zod_1.z.object({
        thesis: zod_1.z.boolean(),
        installable: zod_1.z.boolean().optional(),
        lastname: zod_1.z.string(),
        firstname: zod_1.z.string(),
        orderRegistrationNumber: zod_1.z.string(),
    }),
});
exports.addDoctorSubstituteContractApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('doctor-substitute-contracts'),
        attributes: zod_1.z.object({
            from: zod_1.z.string(),
            to: zod_1.z.string(),
            retrocessionRate: zod_1.z.number().nullable(),
            documentUrl: zod_1.z.string(),
            doctorSubstituteSignedAt: zod_1.z.coerce.date().nullable(),
            metadata: exports.doctorSubstituteContractMetadata,
            createdAt: zod_1.z.coerce.date(),
        }),
    }),
});
